import {
  getWorkspaceData,
  getWorkspaceDataSlim,
  updateWorkspace as requestUpdateWorkspace,
  updateWorkspaceProviderNote as requestUpdateWorkspaceProviderNote
} from "@utils/aegean_api_handler";

export const GET_WORKSPACE_DATA_REQUEST = "GET_WORKSPACE_DATA_REQUEST";
export const GET_WORKSPACE_DATA_SUCCESS = "GET_WORKSPACE_DATA_SUCCESS";
export const GET_WORKSPACE_DATA_ERROR = "GET_WORKSPACE_DATA_ERROR";
export const UPDATE_WORKSPACE_DATA_REQUEST = "UPDATE_WORKSPACE_DATA_REQUEST";
export const UPDATE_WORKSPACE_DATA_SUCCESS = "UPDATE_WORKSPACE_DATA_SUCCESS";
export const UPDATE_WORKSPACE_DATA_ERROR = "UPDATE_WORKSPACE_DATA_ERROR";
export const UPDATE_WORKSPACE_PROVIDER_NOTE_REQUEST = "UPDATE_WORKSPACE_PROVIDER_NOTE_REQUEST";
export const UPDATE_WORKSPACE_PROVIDER_NOTE_SUCCESS = "UPDATE_WORKSPACE_PROVIDER_NOTE_SUCCESS";
export const UPDATE_WORKSPACE_PROVIDER_NOTE_ERROR = "UPDATE_WORKSPACE_PROVIDER_NOTE_ERROR";

export const fetchWorkspaceData = workspace_id => (dispatch) => {
  // TODO: Don't request if the data is up to date

  dispatch({
    type: GET_WORKSPACE_DATA_REQUEST,
    workspace_id
  });

  const feelingSlim = localStorage.slim;
  const workspaceCall = feelingSlim ? getWorkspaceDataSlim : getWorkspaceData;

  return workspaceCall(workspace_id)
    .then((workspace) => {
      dispatch({
        type: GET_WORKSPACE_DATA_SUCCESS,
        workspace,
        workspace_id
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_WORKSPACE_DATA_ERROR,
        error,
        workspace_id
      });
    });
};

export const updateWorkspace = (workspace_id, data) => (dispatch) => {
  dispatch({
    type: UPDATE_WORKSPACE_DATA_REQUEST,
    workspace_id
  });

  return requestUpdateWorkspace(workspace_id, data)
    .then((workspace) => {
      dispatch({
        type: UPDATE_WORKSPACE_DATA_SUCCESS,
        workspace,
        workspace_id
      });
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_WORKSPACE_DATA_ERROR,
        error,
        workspace_id
      });
    });
};

export const updateWorkspaceProviderNote = (workspace_id, object_id, note) => (dispatch) => {
  dispatch({
    type: UPDATE_WORKSPACE_PROVIDER_NOTE_REQUEST,
    workspace_id
  });

  return requestUpdateWorkspaceProviderNote(workspace_id, object_id, note)
    .then((workspace) => {
      dispatch({
        type: UPDATE_WORKSPACE_PROVIDER_NOTE_SUCCESS,
        workspace,
        workspace_id
      });
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_WORKSPACE_PROVIDER_NOTE_ERROR,
        error
      });
    });
};
